"use client";

import Button from "@/components/common/shared/Button/button";

const ToggleBtnGroup = ({ t, byModel, resetVehicleForm }) => {
  return (
    <div className="btnBox">
      <Button
        icon="edit"
        iconPosition="left"
        onClick={() => resetVehicleForm(false)}
        className={byModel ? "" : "active"}
        theme={`${byModel ? "grey-secondary-btn" : "white-secondary-btn"}`}
      >
        {t("vehicle.byRegistration")}
      </Button>
      <Button
        icon="car"
        iconPosition="left"
        onClick={() => resetVehicleForm(true)}
        className={byModel ? "active" : ""}
        theme={`${!byModel ? "grey-secondary-btn" : "white-secondary-btn"}`}
      >
        {t("vehicle.byModel")}
      </Button>
    </div>
  );
};

export default ToggleBtnGroup;
